
import * as React from "react"
import { ToastContainer } from 'react-toastify';
import PropTypes from "prop-types"
import Header from '../../../shared/header2';
import Footer from '../../../shared/footer';
import { Helmet } from "react-helmet";
import "./layout.css";
import "../styles/app.scss";
import 'react-toastify/dist/ReactToastify.css';

const Layout = ({ children }) => {

  return (<>

    <link href="https://use.typekit.net/vao4ikf.css" rel="stylesheet" />
    
    <Helmet>
      <body className="elbrus-headless"/>
    </Helmet>

    <div className="community-box">
      <Header />
      <>
        <>{children}</>
        <Footer />
      </>
      <ToastContainer />

    </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
